import { BillingTypeSellModelType } from '@teinor/erp/types/company/config/billingGroup/billingTypeSell'
import { useMemo } from 'react'
import { useParams } from 'react-router-dom'
import { ComponentWithPermissions } from '../../../../../../baseComponents/CreateRoutering/types'
import DoubleTable from '../../../../../../baseComponents/DoubleTable'
import { useAddDoubleTableGreenRowRender } from '../../../../../../baseComponents/DoubleTable/functions'
import { permissionCheck } from '../../../../../../baseComponents/PermissionChecker/function'
import useTwinTranslation from '../../../../../../utils/hooks/useTwinTranslation'
import ConfigBillingTypeSellOptions from './ConfigBillingTypeSellOptions'
import ConfigBillingTypeSellSortButton from './ConfigBillingTypeSellSortButton'
import ModalCEConfigBillingTypeSell from './ModalCEConfigBillingTypeSell'
import BaseScreenTable from '../../../../../../baseComponents/TwinTable/BaseScreenTable'
import { TableComponentProps } from '../../../../../../baseComponents/TwinTable/BaseScreenTable/types'
import { ColumnTableSchema } from '../../../../../../baseComponents/TwinTable/VirtualTableListing/Subcomponents/types'
import { CustomRenderBoolean, EditRow } from '../../../../../../baseComponents/TwinTable/VirtualTableListing/CustomRenders'
import { TwinTableLink } from '../../../../../../baseComponents/TwinTable'
import locations from '../../../../../../utils/globals/locations'


interface ConfigBillingTypesSellProps extends ComponentWithPermissions { }

const ConfigBillingTypesSell: React.FC<ConfigBillingTypesSellProps> = ({ userPermissions }) => {
    const { BillingTypeSellId } = useParams()
    return (<DoubleTable userPermissions={userPermissions} FirstChild={BillingTypesSell} SecondChild={ConfigBillingTypeSellOptions} displaySecond={BillingTypeSellId !== 'main'} />)
}


interface BillingTypesSellProps extends ComponentWithPermissions { }

const BillingTypesSell: React.FC<BillingTypesSellProps> = ({ userPermissions }) => {
    const { t } = useTwinTranslation()

    const pageData = {
        title: t('billingTypeSell', 'Tipos de Facturación Venta'),
        newText: t('newBillingTypeSell', 'Nuevo Tipos de Facturación Venta'),
    }

    return (
        <BaseScreenTable TableComponent={TableBillingTypesSell} CreateModalComponent={ModalCEConfigBillingTypeSell} EditModalComponent={ModalCEConfigBillingTypeSell} pageData={pageData} userPermissions={userPermissions} />
    )
}

interface TableBillingTypesSellProps extends TableComponentProps {}

const TableBillingTypesSell: React.FC<TableBillingTypesSellProps> = ({ userPermissions, setTableInstance, setOpened, tableInstance }) => {
    const { t } = useTwinTranslation()
    const { BillingGroupId, BillingTypeSellId } = useParams()
    const { rowRenderer } = useAddDoubleTableGreenRowRender(BillingTypeSellId || '')

    const columns: ColumnTableSchema<BillingTypeSellModelType> = [
        {
            id: 'order',
            dataKey: 'order',
            label: t('order', 'Order'),
            sortable: true,
            width: 100
        },
        {
            id: 'name',
            dataKey: 'name',
            label: t('name', 'Nombre'),
            sortable: true,
            searchableComponent: {
                component: 'SearchableComponentBasic',
                extraComponentData: { label: t('name', 'Nombre') }
            }
        },
        {
            id: 'mandatory',
            dataKey: 'mandatory',
            label: t('mandatory', 'Obligatorio'),
            customRender: (parameterValue) => <CustomRenderBoolean value={String(parameterValue) === 'true'} width={75} />,
        },
        {
            id: 'edit',
            dataKey: 'id',
            label: '',
            width: 50,
            customRender: (parameterValue, allRowData) => <EditRow key={'edit' + parameterValue} {...{ parameterValue, allRowData }} onClick={(_idk, allRowData) => setOpened({ type: 'edit', allRowData })} />,
            havePermission: permissionCheck(userPermissions, 'update')
        },
    ]
    const children = useMemo(() => <ConfigBillingTypeSellSortButton tableInstance={tableInstance} userPermissions={userPermissions} />, [tableInstance, userPermissions])

    return (
        <TwinTableLink name='billingTypesSell' extraWhereParams={{ BillingGroupId }} hideLoadFiltersButton={true} columns={columns} getDataFrom='/api/app/config/billingGroup/billingTypeSell/getAllBillingTypesSell' rowRenderer={rowRenderer} setTableInstance={setTableInstance} createRowDataLink={[locations.configBillingTypeSell, [String(BillingGroupId || ''), '$id']]} defaultOrder={{ defaultOrderField: 'order', order: 'asc' }}>
            {children}
        </TwinTableLink>
    )
}


export default ConfigBillingTypesSell